import { HTMLAttributes } from 'react'
import { cn } from '@vgw/tailwind-merger'

type ContentProps = HTMLAttributes<HTMLElement>

export const Content = ({ children, className, ...props }: ContentProps) => {
  return (
    <main
      className={cn(
        'flex w-full flex-1 flex-col items-center bg-surface-secondary',
        className,
      )}
      {...props}
    >
      <div className="flex w-full max-w-(--breakpoint-2xl) items-center">
        {children}
      </div>
    </main>
  )
}
